<template>
  <div >
    <div v-if="channel != undefined"  >
   <div   v-bind:style="'background-color: '+(channelColor)+''" class=" custom-shit text-center w-100 " >
    <div class="container" >
        <a  style=" color:white;font-weight:lighter;font-size:1.6em; width:100%" v-bind:href="'/'+channel.id">   

            {{ channel.name }}
        </a>
<br />
<span style=" color:white">@{{ channel.id }}<br /> 
     <button v-if="doesFollow == undefined"  style="padding:0.1em; padding-left:0.4em;padding-right:0.4em;margin-top:5px; font-size: 0.8em" class="btn btn-outline-light">...</button>
  <button v-if="doesFollow == true" @click="follow(false)" style="padding:0.1em; padding-left:0.4em;padding-right:0.4em;margin-top:5px; font-size: 0.8em" class="btn btn-outline-light">{{$t('Following')}} <i class="fas fa-user-check"></i></button>
  <button v-if="doesFollow == false" @click="follow(true)" style="padding:0.1em; padding-left:0.4em;padding-right:0.4em;margin-top:5px; font-size: 0.8em" class="btn btn-outline-light">{{$t('Follow')}} <i class="fas fa-user-plus"></i></button></span><br />

<div class="center-child"> <router-link v-bind:to="'/'+channel.id" class="channel-link-nav ">{{$t('Home')}}</router-link> <a v-bind:href="'/'+channel.id+'/recordings'" class="channel-link-nav">{{$t('Recordings')}}</a> <a v-bind:href="'/'+channel.id+'/schedule'" class="channel-link-nav channel-link-nav-selected">{{$t('Schedule')}}</a></div>
  </div>
</div>



 
<br />

 <div class="container">
   
     <div class=" ">
 
</div>

      <br />
   
 <br />
          <h3>{{ $t('Schedule') }}</h3>
     <hr />
     <div v-if="scheduledList">
     <p v-if="scheduledList.length==0"> {{ $t('NoScheduledEvents') }}</p>
     <div class="row">

  <div class="col-md-6 p-2" v-for="event in scheduledList" v-bind:key="event.id" >
      <event :event="event" :channel_id="channel.id"  >
      </event> 
</div>
</div>
</div>
 <div v-else>
  <p class="w-100 text-center"> Loading Schedule...</p> 
               <scale-loader  :color="channelColor || 'darkblue'" ></scale-loader>

   </div>
<br /> 
</div>
<br />
<br />
<footer style="text-align:center;">
  <small>© {{ new Date().getFullYear()}} {{ channel.name}}<br>{{ $t('AllRightsReserved') }}</small>
</footer>
<br />
<br />
  </div>
 </div>
</template>

<script>

import event from '../components/Event.vue'
import axios from "axios"
import Swal from "sweetalert2"
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import tinycolor from 'tinycolor2'
let API = "https://app.seasoncast.com/"
   import cookie from "cookie.js"

export default {
  name: 'Home',
  components: {
    event,
    ScaleLoader
  },
  data: function () {
    return {
      recordingsList: undefined,
        channel_id: this.$route.params.channel,
        channel: undefined,
         scheduledList: undefined,
          doesFollow: undefined
    }
  },
   beforeDestroy () {
  this.$global.smallerNavBar = false
},
mounted (){
    this.$global.smallerNavBar = true;
},
   beforeMount () {
    
  this.$global.smallerNavBar = true
},
computed: {
  channelColor:  function(){
    var color = tinycolor(this.channel.pageData ?  this.channel.pageData.navcolor : '000000')
    if (color.getLuminance() > 0.8){
      color = color.darken(20)
    }
   return color.toHexString()
  }
},
  created: async function () {
  
  console.log("output")

await this.getChannel()

if (this.channel){
await this.getChannelSchedule()
}
if (!cookie.get("viewer-token")){
this.doesFollow = false
}else{
  this.doesFollowCall()
}
  },
  methods: {
 getChannel: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/channel", {
    channel_id: this.$route.params.channel,
 
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
      await Swal.fire({
  icon: 'error',
  title: 'Server Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
this.$router.push('/');
return
  }

console.log(responseData)
  this.channel = responseData.channel
    

document.title = this.channel.name + " | SeasonCast"
    },
      getChannelSchedule: async function () {
      
    let getEventResponse = await axios.post(API+ "v2/channel/schedule", {
    channel_id: this.$route.params.channel,
    start: 0,
    end: 20,
    stats: true
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData)
  this.scheduledList = responseData.result

if (this.scheduledList.length > 0){
this.future_event = this.scheduledList[0]
}


    },

        doesFollowCall: async function () {
      //could add more parametes later
    let getEventResponse = await axios.post(API+ "v2/viewer/doesFollow", {
     email: cookie.get("viewer-email"),
    token:  cookie.get("viewer-token"),
    channel_id: this.$route.params.channel
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
    console.log("error loading does follow")
  }

  this.doesFollow = responseData.doesFollow
    


    },
      follow: async function (shouldFollow){
 

  let getViewerToken = cookie.get("viewer-token")
    if (!getViewerToken ){
        await Swal.fire('Please create a free account to follow '+this.channel.name+'!')

        this.$router.push('/viewer/login?return='+(this.$route.fullPath + "?action=follow"));
        return
    }

 let getEventResponse = await axios.post(API+ "v2/viewer/changeFollowing", {
   email: cookie.get("viewer-email"),
    token:  cookie.get("viewer-token"),
    channel_id: this.$route.params.channel,
    shouldFollow
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
    console.log("error loading does follow")
  }
this.doesFollow = shouldFollow
    },
  }
}
</script>
<style scoped lang="scss">
.container {
    max-width: 1100px;
}


.sc-link{
  color: white !important;
}

.custom-shit{
  padding-top: 30px;
  font-weight:500;

  //border-radius: 0.2em;
}

.channel-link{
     display: flex;
  justify-content: center;
  align-items: center;

}
.custom-shit a{
  text-decoration:none;
}
.center-child {
font-weight:800;
 

display: flex;
    flex-flow: row wrap;
    text-align: center;

    width: auto;
    justify-content: center;
  
}

.channel-link-nav{
  
  color:rgb(223, 223, 223);
  padding: 2px;
  margin: 0.5em;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100px;
}

.channel-link-nav:hover{
  color:white;
  cursor: pointer;
    border-bottom: 2px solid rgb(247, 247, 247);

}

.channel-link-nav-selected{
  border-bottom: 2px solid rgb(247, 247, 247);
  color:white;
}

</style>
